/**
 * Attention Objects page (Phase C placeholder).
 *
 * Phase C (nav simplification) adds this route so the production nav reflects
 * the locked target shape. The controlled Attention Object Library (thought
 * pieces and case study snippets, admin add / tag / approve / retire, and
 * strong-match recommendations against signals and contacts) is built in a
 * later feature phase. No feature logic or data access lives here yet; this is
 * a deliberate empty state, not a broken page.
 */
export function AttentionObjects() {
  return (
    <div>
      <header className="bdse-page-header">
        <h1 className="bdse-page-title">Attention Objects</h1>
        <p className="bdse-page-subtitle">
          Approved assets you can send: thought pieces and case study snippets
        </p>
      </header>

      <div className="bdse-glass-surface p-8 max-w-3xl">
        <h2 className="text-sm font-semibold text-bdse-text mb-2">
          The library is being set up
        </h2>
        <p className="text-sm text-bdse-text-secondary leading-relaxed">
          Once assets are added and approved, BDSE will recommend a strong match
          on a signal or contact. When no strong match exists, it will say so
          honestly and suggest a content gap worth developing.
        </p>
      </div>
    </div>
  );
}
